import { trim } from 'lodash';

export const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function regexToPattern(regex: RegExp): string {
  return trim(regex.toString(), '/');
}
